<nz-space class="mobile-report-control">
  <app-stock-location-select [showAddNewButton]="false" [(ngModel)]="from" class="report-control"
    (ngModelChange)="onFromChange($event)" valueField="code" [disabled]="to === 'ALL' || to === 'NULL'">
  </app-stock-location-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-stock-location-select [showAddNewButton]="false" [(ngModel)]="to" class="report-control"
    (ngModelChange)="onToChange($event)" valueField="code" [disabled]="from === 'ALL' || from === 'NULL'">
  </app-stock-location-select>
</nz-space>